import { Component, Input } from '@angular/core';
import { MapFeature } from '../../map/core/map-feature';
import { MapFeatureManagerService } from '../../map/core/map-feature-manager.service';

@Component({
  selector: 'app-sidebar-control',
  templateUrl: './sidebar-control.component.html',
  styleUrls: ['./sidebar-control.component.css']
})
export class SidebarControlComponent {
  @Input() feature!: MapFeature;

  constructor(private featureManager: MapFeatureManagerService) { }

  /** The eye: show/hide this layer's objects on the map. Visibility is the
   *  layer's own state — independent of which layer is active, and persistent. */
  toggleVisibility(): void {
    this.featureManager.toggleFeature(this.feature.key);
  }
}
